// GENERATED FILE - DO NOT MODIFY

export enum InvoiceStatusDto {
    AwaitingPayment = "AwaitingPayment",
    Pending = "Pending",
    Failed = "Failed",
    Paid = "Paid",
    Void = "Void",
    Refunded = "Refunded",
}